// Author thq
// Date 2021-04-15 17:25:44

import * as model from "@/model/em/spareparts/EmSppStorageCatSscModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {levelTreePatternFactory} from "@/store/em/commonPattern/levelTreePatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.EmSppStorageCatSsc(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_SPAREPARTS_URL,
    })
    .withPatternFactory(levelTreePatternFactory, {
        entity: 'emSppStorageCatSsc',
        modelFilter: model.filter
    })
    .buildStore()
